var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('b-modal', {
    ref: "myModalRef",
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Clients Remittance E-Mail Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeModal(false)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "1rem",
      "color": "red",
      "line-height": "1.5 !important"
    }
  }, [_vm._v("Do you want to proceed to send an email to selected clients ?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('center', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "background-color": "#28a745"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeModal(true)
      }
    }
  }, [_vm._v("Proceed")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "background-color": "#dc3545"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeModal(false)
      }
    }
  }, [_vm._v("Cancel")])])], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Client Name "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'error': _vm.errors.has('AccountId')
    },
    staticStyle: {
      "border": "1px solid #c2cfd6",
      "z-index": "999"
    },
    attrs: {
      "options": _vm.ClientAccountList,
      "multiple": _vm.multiple(),
      "name": "AccountId",
      "id": "AccountId",
      "data-ClientId": _vm.ClientId,
      "placeholder": "Select Client",
      "label": "AccountName",
      "track-by": "AccountId",
      "optionHeight": 100,
      "hide-selected": true
    },
    model: {
      value: (_vm.ClientId),
      callback: function($$v) {
        _vm.ClientId = $$v
      },
      expression: "ClientId"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_c('p', [_vm._v("No Record Found.")])])], 2)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('AccountId')),
      expression: "errors.has('AccountId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Client is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Transaction From Date "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('fromDate')
    },
    attrs: {
      "id": "fromDate",
      "type": "date",
      "name": "fromDate"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fromDate')),
      expression: "errors.has('fromDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Transaction from date is required.")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "fdate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Transaction To Date "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('toDate')
    },
    attrs: {
      "id": "toDate",
      "type": "date",
      "name": "toDate"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('toDate')),
      expression: "errors.has('toDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Transaction to date is required.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Clear")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Client's Result\n                    "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSent),
      expression: "isSent"
    }],
    staticStyle: {
      "margin-left": "80%",
      "cursor": "pointer"
    },
    attrs: {
      "title": "Click to send an email with report to selected clients"
    },
    on: {
      "click": function($event) {
        _vm.showModal()
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary velmld-parent",
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "disabled": _vm.disableButton,
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope",
    staticStyle: {
      "font-size": "medium"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Send")])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables scrolltb",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_vm._m(2), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "7%"
    }
  }, [(_vm.resultCount > 0) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAll),
      expression: "checkAll"
    }],
    staticStyle: {
      "margin-left": "-7px"
    },
    attrs: {
      "type": "checkbox",
      "id": "checkall",
      "name": "checkall"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAll) ? _vm._i(_vm.checkAll, null) > -1 : (_vm.checkAll)
    },
    on: {
      "click": _vm.check,
      "__c": function($event) {
        var $$a = _vm.checkAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAll = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checkAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAll = $$c
        }
      }
    }
  }) : _vm._e(), _vm._v(" All\n                            ")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10)])]), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0) ? _c('tr', [_vm._m(11)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listEmailRemittanceData), function(data, index) {
    return (_vm.resultCount > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.pageno + index + 1))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.filepath != null && data.EmailStatus == 'Pending') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ClientArr),
        expression: "ClientArr"
      }],
      staticClass: "checkedChild",
      attrs: {
        "type": "checkbox",
        "name": _vm.setid('ClientId', data.clientremittedid),
        "id": _vm.setid('ClientId', data.clientremittedid)
      },
      domProps: {
        "value": data.clientremittedid,
        "checked": Array.isArray(_vm.ClientArr) ? _vm._i(_vm.ClientArr, data.clientremittedid) > -1 : (_vm.ClientArr)
      },
      on: {
        "change": function($event) {
          _vm.updateCheck(data)
        },
        "__c": function($event) {
          var $$a = _vm.ClientArr,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data.clientremittedid,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.ClientArr = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ClientArr = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ClientArr = $$c
          }
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.CompanyName))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(data.EmailId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.Cycle))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.format_date(data.transactiondate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.PaidAmount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.UTRNo))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.filepath != null) ? _c('span', [_c('a', {
      attrs: {
        "title": ("" + (data.CompanyName)),
        "href": ("" + (data.filepath))
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      staticStyle: {
        "font-size": "20px",
        "color": "#4b8cbb",
        "margin": "10px 10px 1px 1px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (data.filepath == null) ? _c('span', [_c('a', {
      attrs: {
        "title": ("" + (data.CompanyName))
      }
    }, [_vm._v("NA")])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.EmailStatus == 'Pending') ? _c('span', {
      staticClass: "badge badge-danger",
      staticStyle: {
        "font-size": "11px",
        "border-radius": "5px"
      }
    }, [_c('i', {
      staticClass: "fa fa-circle-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Pending")]) : _vm._e(), _vm._v(" "), (data.EmailStatus == 'Sent') ? _c('span', {
      staticClass: "badge badge-success",
      staticStyle: {
        "font-size": "12px",
        "border-radius": "5px"
      }
    }, [_c('i', {
      staticClass: "fa fa-check-circle-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Sent")]) : _vm._e()])]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.resultCount > 1) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '«',
      "next-text": '»',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    staticClass: " fa fa-filter filter"
  }), _vm._v("E-Mail Remittance\n                ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('b', [_vm._v("#")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('b', [_vm._v("Company Name")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "22%"
    }
  }, [_c('b', [_vm._v("Company E-Mail")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('b', [_vm._v("Cycle")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Transaction"), _c('br'), _vm._v(" Date")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v("Paid Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("UTR #")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Download")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Report")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_c('b', [_vm._v("No record found..!")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77e36f95","hasScoped":true}!./src/views/components/emailremittance/emailremittance.component.html
// module id = 695
// module chunks = 1